// App.js
import { useState, useEffect, useRef } from 'react'
import { SiteNavBar } from './components/Website_Components/SiteNavBar'
import App_sub from './App_sub'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { Box, Grid, Paper, Typography, Divider, Button, List, ListItemText } from '@mui/material'
import VisibilityOffTwoToneIcon from '@mui/icons-material/VisibilityOffTwoTone'
import VisibilityTwoToneIcon from '@mui/icons-material/VisibilityTwoTone'
import RelatedLinks from './components/BlogComponents/RelatedLinks/RelatedLinks'
import { /*UniversalSliderHorizontal,*/ UniversalDropDown } from '@fileops/swmm-react'
import UniversalSliderHorizontal from './components/SwmmReact_Staging/UniversalSliderHorizontal'
import UniversalCheckbox from './components/SwmmReact_Staging/UniversalCheckbox'
import ExternalLinks from "./components/BlogComponents/ExternalLinks/ExternalLinks"
import { SwmmConvert } from "@fileops/swmm-node"
import { SwmmOut } from '@fileops/swmm-node'
import { SwmmRpt } from '@fileops/swmm-node'
import { SwmmOutChartjs } from './components/Charting_Components/SwmmOutChartjs'
import SwmmFlow_Chart from './SwmmFlow_Chart'
import SwmmReactUI from "./components/SwmmReact_Staging/SwmmReactUI"
import MainText from './MainText'

import './swmm-chart.css'
import 'mapbox-gl/dist/mapbox-gl.css'

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    marginLeft: '10px',
    paddingLeft: '10px',
    spacing: '10px',
    backgroundColor: '#efefef'
  },
  components: {
    MuiTypography: {
      styleOverrides: {
        gutterBottom: {
          marginBottom: 40,
        },
      },
    },
  },
})

const swmmInp = "./extraResources/dstore-imperv.inp"
const rptFile = './extraResources/dstore-imperv.rpt'
const outFile = './extraResources/dstore-imperv.out'
let baseModel = {}
let modelRun_1 = 0

const urlParams = new URLSearchParams(window.location.search)
// targetTypeString is one of NODES, LINKS, or SUBCATCHMENTS
const targetTypeString = "SUBCATCHMENTS"//urlParams.get('targetType')?urlParams.get('targetType'):undefined
// targetString is the ObjectID of the target
const targetString = "53"//urlParams.get('targets')?urlParams.get('targets').slice(1,-1):undefined
const targetArray = targetString?targetString.split(','):undefined
// showChartControlsString: true if chart controls are visible
const showChartControlsString = urlParams.get('showChartControls')?urlParams.get('showChartControls'):'true'
// Get the array of controls, if supplied
const controlString = '[["SUBCATCHMENTS","53","Area",.3,1.5,0.1,"Subcatchment 53 Area, Hectares"],["XSECTIONS","Weir","Geom2",0.1,0.5,0.01,"Length, Weir"]]'
const controls = [
  ["LID_USAGE",["53", "0"],"Number",0,1331,10,"Number of Green Roof Units"],
  //["XSECTIONS","Weir","Geom2",0.1,0.5,0.01,"Length, Weir"],
  ["LID_USAGE", ["53", "0"],"ToPerv", "Return All Outflow to Perv. Area, Green Roof"],
  ["SUBCATCHMENTS","53","Area",.3,1.5,0.1,"Subcatchment 53 Area, Hectares"]
]//JSON.parse(controlString)

//model_1.LID_USAGE['53'][0].ToPerv



// Any of 
/**
 * "Rainfall", "Snow Depth", "Evap", "Infiltration", "Runoff", "GW Flow", "GW Elev", "Soil Moisture"
 * "Depth", "Head", "Volume", "Lat. Flow", "Inflow", "Overflow"
 * "Flow", "Depth", "Velocity", "Volume", "Capacity"
 */
const targetParamString = "Runoff"//urlParams.get('targetParam')?urlParams.get('targetParam'):undefined
const targetParam = (targetTypeString&&targetString)?SwmmOut[targetTypeString.slice(0, -1)+'_RESULTS'].indexOf(targetParamString):undefined

export default function App() {
  const [precip, setPrecip] = useState(100)
  const [depth, setDepth] = useState(0)
  const [units, setUnits] = useState(undefined)
  const [targetType, settargetType] = useState(targetTypeString)
  const [targetParameter, settargetParameter] = useState(targetParam)
  const [targetParameterVal, settargetParameterVal] = useState(undefined)
  const [dataWordsType, setDataWordsType] = useState(undefined)
  const [resultArrayName, setResultArrayName] = useState(undefined)
  const [IDs, setIDs] = useState(["NODES", "LINKS", "SUBCATCHMENTS"])
  const [target, settarget] = useState(/*targetString*/targetArray)
  const [objectIDs, setObjectIDs] = useState([])
  const [targetSection, setTargetSection] = useState(undefined)
  const [targetObjectID, setTargetObjectID] = useState(undefined)


  const [model_1, setModel_1] = useState(baseModel)
  const [out_1, setOut_1] = useState(null)
  const [rpt_1, setRpt_1] = useState(null)
  const [light, setLight] = useState(true)
  const [modelRun_1, setModelRun_1] = useState(0)
  const [displayText, setDisplayText] = useState(true)
  // Add a state to track if the data is loaded
  const [dataLoaded, setDataLoaded] = useState(false);

  const videoRef = useRef(null)
  const videoRef2 = useRef(null)
  // setModelRun should be sent to any SwmmReactUI component when you have the 'Run Model'
  // command available.
  // modelRun should be sent to any SwmmReactUI that you wish to display results for after a run.
  // For single-model, multi-display setups:
  //   setModelRun should be sent to any component that is not 'mapOnly === true'
  //   modelRun    should be sent to only the main interface, usually the top interface.

  
const setModelInstant = (val) =>{
  setModel_1(val)
  setModelRun_1(prev=>prev+1)
}

const infoTextVisibility = () => {
  document.getElementsByClassName('info-text')[0].classList.toggle('show-info-text')
}
  /**
   * Dropdown menu data population. This could be a target for cleanup.
   */
  useEffect(()=>{
    if(out_1 && out_1.value.byteLength > 0){
      if(targetType === 'NODES'){
        setResultArrayName('NODE_RESULTS')
        settargetParameterVal(2)
        setObjectIDs([...Array(out_1.totalNodes).keys()].map((o, i)=>out_1.nodeName(i)))
        setDataWordsType('NODE')
      } else if (targetType === 'LINKS'){
        setResultArrayName('LINK_RESULTS')
        settargetParameterVal(1)
        setObjectIDs([...Array(out_1.totalLinks).keys()].map((o, i)=>out_1.linkName(i)))
        setDataWordsType('LINK')
      } else if (targetType === 'SUBCATCHMENTS'){
        setResultArrayName('SUBCATCHMENT_RESULTS')
        settargetParameterVal(0)
        setObjectIDs([...Array(out_1.totalSubcatchments).keys()].map((o, i)=>out_1.subcatchmentName(i)))
        setDataWordsType('SUBCATCH')
      }
    }
    //settargetParameter(-1)
    //settarget(-1)
  }, [out_1, targetType])

  const theme = {
    backgroundColor: light? "White": "grey",
    color: light?"grey":"white"
  }

  const marginBottomSection = '60px'
  
  const updateValue = (val, type) => {
    if(model_1 && model_1.LID_USAGE){
      // Copy the object at the target position.
      let thisObj = JSON.parse(JSON.stringify(model_1.LID_USAGE['53']))
      // Update the value.
      thisObj[0][type] = val
      // Replace the object at the target position.
      setModel_1(prev => ({
        ...prev,
        LID_USAGE:{
          ...prev.LID_USAGE,
          ['53']: thisObj
        }
      }))
    }
  }

  // Fetch and set the initial model data
  // Run this only on mount
  useEffect(() => {
    async function fetchData() {
      try {
        const responseInp = await fetch(swmmInp)
        const text = await responseInp.text()
        
        const jsonSWMM = SwmmConvert.parseInput(text)
        // If there isn't a PCS and TRANSFORM section in the file, add them
        if(jsonSWMM.PCS == null){
          jsonSWMM.PCS = {
            swmmNode_proj: {
                "proj": "utm",
                "zone": "19",
                "datum": "WGS84",
                "units": "ft",
                "defs": "no_defs"
            }
          }
        }
        if( jsonSWMM.TRANSFORM == null ){
          jsonSWMM.TRANSFORM = {
            swmmNode_t: {
              "x": 1661000,
              "y": 4378000,
              "size": 1,
              "rotation": 0
            }
          }
        }
        if(jsonSWMM.MAP == null){
          jsonSWMM.MAP = {
            "DIMENSIONS": {
                "x1": 0,
                "y1": 0,
                "x2": 10000,
                "y2": 10000
            },
            "Units": "None"
          }
        }
        setModel_1(jsonSWMM)
        
        if(outFile && outFile !== ''){
          const responseOut = await fetch(outFile)
          const binary = await responseOut.arrayBuffer()
          let swmmOut = new SwmmOut(binary)
          setOut_1(swmmOut)
        }

        if(rptFile && rptFile !== ''){
          const responseRpt = await fetch(rptFile)
          const report = await responseRpt.text()
          setRpt_1(report)
        }

        baseModel = jsonSWMM
        setDataLoaded(true)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const handleScrollAndResize = () => {
      // Restart the video by setting currentTime to 0
      if (videoRef.current) {
        videoRef.current.currentTime = 0;
        videoRef.current.play();
      }
      if (videoRef2.current) {
        videoRef2.current.currentTime = 0;
        videoRef2.current.play();
      }
    };

    // Attach event listeners for scroll and resize
    window.addEventListener('scroll', handleScrollAndResize);
    window.addEventListener('resize', handleScrollAndResize);

    return () => {
      // Remove event listeners on component unmount
      window.removeEventListener('scroll', handleScrollAndResize);
      window.removeEventListener('resize', handleScrollAndResize);
    };
  }, []);

  /**
   * 
   * ID               DateTime       Value
Rainfall                    0       1         
Rainfall                    1       0         
   */
  /*useEffect(()=>{
    if(model_1 && model_1.OPTIONS){
      setModel_1(prev => ({
        ...prev, TIMESERIES: {
          ...prev.TIMESERIES, Rainfall01:[
            {DateTime: 0, Value: precip/100*2},
            {DateTime: 1, Value: 0},
          ]
        }
      }))
      setModelRun_1(prev=>prev+1)
    }
  }, [precip])*/
  

  /**
   * ;;Subcatchment   N-Imperv   N-Perv     S-Imperv   S-Perv     PctZero    RouteTo    PctRouted 
   * LotA             0.01       0.1        0.05       0.05       20         OUTLET
   * LotB             0.01       0.1        0.05       0.05       20         OUTLET
   * LotC             0.01       0.1        0.05       0.05       20         OUTLET
   */
  useEffect(()=>{


    if(model_1 && model_1.OPTIONS){
    
    let lotArray = ['NoImperv', 'Pct50Imperv', 'AllImperv']
    let newValues = {}

    lotArray.forEach((v, i) => {
      newValues = {...newValues, [v]: {
        ...model_1.SUBAREAS[v], 
        SImperv: precip/100
      }}
    });

    

    console.log(newValues)

      setModel_1(prev => ({
        ...prev, SUBAREAS: {
          ...prev.SUBAREAS, 
          ...newValues
        }
      }))
      setModelRun_1(prev=>prev+1)
    }
    console.log(model_1)
  }, [precip])

  useEffect(()=>{
    console.log(model_1)
  }, [model_1])
  

  return(
    <div style={theme}>

    {/*<SiteNavBar style={{backgroundColor: 'rgba(0, 0, 0, 1)'}} />*/}
    {/* Talk about the model */}
    <ThemeProvider theme={lightTheme} >
      <Grid container style={{background: 'black'}}>
                <div style={{position: 'relative', maxHeight: '100vh', width: 'auto', top: '0px', left:'0px', margin: 'auto'}}>
                  {/*<img id={"image-main"} style={{position: 'relative', width: 'auto', maxHeight: '100vh'}} src={'./coffee_blue.jpg'} >
                  </img>*/}
                  {/*<video ref={videoRef} id={"video-main"} style={{position: 'absolute', top: '0px', left: '0px', width: 'auto', maxHeight: '100vh', opacity: (precip/25)}} src={'./video_blue_med_bitrate15.mp4'} controls={false} autoPlay playsInline muted loop >
                  </video>*/}
                  {<video ref={videoRef} id={"video-main"} style={{position: 'relative', top: '0%', left: '0%', width: 'auto', maxHeight: '100vh', opacity: (1)}} src={'./dstore-imperv.mp4'} controls={false} autoPlay playsInline muted loop >
                  </video>}
                  {/*<div className='swmmchart-container' style={{background: 'rgba(0, 0, 0, 0.8)'}}>
                    <div className='swmmchart-top' style={{}}>
                      <SwmmFlow_Chart model_1={model_1} out_1={out_1} targetParamString={'Runoff'} targetTypeString={'SUBCATCHMENTS'} targetArray={['BlockA', 'BlockB', 'BlockC']} showChartControlsString={'true'} lineSize={1} modelRun_1={modelRun_1}/>
                    </div>
                    <div style={{margin: '20px 0 0 10px'}}>
                      Rainfall, {precip/100*2} inches/hr
                    </div>
                    <input  type = "range"
                      style={{width: '70%', margin: '0 0 0 15%', touchAction: 'none'}}
                      min = {0}
                      max = {100}
                      step = {1}
                      onChange={(e) => {
                        setPrecip(e.target.value)
                      }}
                      value={precip}
                    />
                    <div style={{margin: '20px 0 0 10px'}}>
                      Depth, {(depth/100*2).toFixed(2)} inches
                    </div>
                    <input  type = "range"
                      style={{width: '70%', margin: '0 0 0 15%', touchAction: 'none'}}
                      min = {0}
                      max = {3.5}
                      step = {0.1}
                      onChange={(e) => {
                        setDepth(e.target.value)
                      }}
                      value={depth}
                    />
                    </div>*/}
              </div>

      </Grid>
      <div className='info-text' >
        <Typography variant='h2' textAlign='right' gutterBottom>
          Depression Storage, Impervious
        </Typography>
        <Typography variant='body1' gutterBottom>
          Impervious depression storage is the depth of water that will be retained by the impervious portion of a subcatchment during a rainfall/discharge event. The rainfall will be accumulated and held within depressions, pores and adhesion mechanisms in the impervious areas. Examples of impervious depression storage include puddles, potholes, cracks, and rough surfaces.
        </Typography>
        <Typography variant='h3' textAlign='left' gutterBottom>
          Interactive Example
        </Typography>
        <Typography variant='body1' sx={{marginBottom: 3}}>
          The following example demonstrates how surface discharge is affected by impervious depression storage. Three subcatchments show how different types of surfaces utilizing the same impervious depression storage value will affect the overland flow caused by rainfall. See the modeling demonstration at the bottom of this text for more information about the constituent variables.
        </Typography>
        <Typography variant='body1' sx={{marginBottom: 3}}>
          The modeled areas are broken down like so: 
        </Typography>
        {<List sx={{listStyleType: 'disc', pl: 4, mb: 4}}>
          <ListItemText sx={{ display: 'list-item' }}>NoImperv: No impervious area.</ListItemText>
          <ListItemText sx={{ display: 'list-item' }}>Pct50Imperv: 50% of the subcatchment is impervious.</ListItemText>
          <ListItemText sx={{ display: 'list-item' }}>NoImperv: All of the subcatchment is impervious.</ListItemText>
        </List>}
        <div style={{height: '300px', background: 'rgba(0,0,0,0.7)'}}>
          <SwmmFlow_Chart model_1={model_1} out_1={out_1} targetParamString={'Runoff'} targetTypeString={'SUBCATCHMENTS'} targetArray={['NoImperv', 'Pct50Imperv', 'AllImperv']} showChartControlsString={'true'} lineSize={1} modelRun_1={modelRun_1}/>
        </div>
        <Typography>Depression Storage, inches: {precip/100}</Typography>
        <input  type = "range"
          style={{width: '70%', margin: '0 0 0 15%', touchAction: 'none'}}
          min = {0}
          max = {100}
          step = {1}
          onChange={(e) => {
            setPrecip(e.target.value)
          }}
          value={precip}
        />
        <Typography variant='h3' textAlign='left' gutterBottom>
          Dstore-imperv
        </Typography>
        <Typography variant='body1' sx={{marginBottom: 3}}>
          EPA-SWMM uses the parameter name 'Dstore-Imperv' to designate impervious depression storage. The guide defines this value as:
        </Typography>
        <Typography sx={{pl: 4, fontStyle: 'italic'}} gutterBottom>
          Depth of depression storage on the impervious portion of the subcatchment (inches or millimeters).
        </Typography>
        <Typography variant='h3' textAlign='left' gutterBottom>
          Modeling Example
        </Typography>
        <div style={{height: '400px'}}>
          {
            model_1 &&
            model_1.OPTIONS &&
            <SwmmReactUI model={model_1} setModel={setModel_1?setModel_1:()=>{}} rpt={rpt_1} setRpt={setRpt_1} swmmOut={out_1} setSwmmOut={setOut_1?setOut_1:()=>{}} height={300} mapOnly={false} inpFile={/*modelParam*/''} rptFile={/*rptParam*/''} outFile={/*outParam*/''} demos={false} /*view={{bounds:[[-111.63921, 35.20226],[-111.65526, 35.19839]], pitch: 0, bearing: 0} }*/ mainTextColor='white' backgroundColor={'black'} loadNew={true} modelRun={modelRun_1} setModelRun={setModelRun_1?setModelRun_1:()=>{}} showReport={false} />
          }
        </div>
      </div>
      <div className='hide-info-text' onClick={()=>{setDisplayText(!displayText); infoTextVisibility();}} >
        {
          displayText?
          <VisibilityOffTwoToneIcon />
          :
          <VisibilityTwoToneIcon />
        }
      </div>
    </ThemeProvider>
    </div>
  )
}